import React, { useEffect } from 'react'
import UserPage from '../../common/UserPage/UserPage';
import Footer from '../../common/Footer/Footer';
import TherapistPage from '../../components/TherapistHomePage/TherapistPage';
import { useDispatch, useSelector } from 'react-redux'
import { getCurrentTherapist } from '../../redux/therapistSlice'

function TherapistHomePage() {
  const dispatch = useDispatch();

  const therapistState = useSelector((state) => state.therapist) || {};
  const { therapist} = therapistState;

  useEffect(() => {
    if (!therapist) {
      dispatch(getCurrentTherapist());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return (
  <div className="min-h-screen flex flex-col">
    <UserPage customImage={therapist?.picture} />
    <div className="flex-1">
      <TherapistPage />
    </div>
    <Footer />
  </div>
)
}

export default TherapistHomePage